import React, { useState } from "react";
import Form from "../components/form";
import "../styles/Careers.css";

const careers = [
  {
    id: "ai-ml",
    title: "AI / ML Engineer",
    description:
      "Work on advanced AI and ML models and deploy scalable systems that solve real problems.",
  },
  {
    id: "backend-dev",
    title: "Backend Developer",
    description:
      "Build secure, high performance APIs and data systems for enterprise grade applications.",
  },
  {
    id: "frontend-dev",
    title: "Frontend Developer",
    description:
      "Create fast, intuitive interfaces that make complex intelligence feel simple.",
  },
  {
    id: "cloud-eng",
    title: "Cloud Engineer",
    description:
      "Design and run scalable cloud infrastructure for modern, data heavy workloads.",
  },
];

function Careers() {
  const [selectedJob, setSelectedJob] = useState(null);

  return (
    <main className="ix-page">
      <header className="ix-hero center">
        <div className="ix-shell">
          <span className="ix-eyebrow">Careers</span>
          <h1>Build the systems that level the field.</h1>
          <p className="ix-hero-lead">
            We are a small team shipping intelligence people can actually use. If that
            is the work you want, we want to hear from you.
          </p>
        </div>
      </header>

      <section className="ix-section">
        <div className="ix-shell">
          <div className="ix-sec-head">
            <span className="ix-eyebrow is-gray">Open positions</span>
            <h2>Roles we are hiring for.</h2>
          </div>
          <div className="cr-list">
            {careers.map((job) => (
              <div className="ix-card cr-card" key={job.id}>
                <div>
                  <h3 className="cr-title">{job.title}</h3>
                  <p>{job.description}</p>
                </div>
                <button
                  type="button"
                  className="ix-btn ix-btn--primary cr-apply"
                  onClick={() => setSelectedJob(job.title)}
                >
                  Apply →
                </button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {selectedJob && (
        <Form jobTitle={selectedJob} onClose={() => setSelectedJob(null)} />
      )}
    </main>
  );
}

export default Careers;
